import { render, staticRenderFns } from "./JointEventContainer.vue?vue&type=template&id=a76a474a&"
import script from "./JointEventContainer.vue?vue&type=script&lang=js&"
export * from "./JointEventContainer.vue?vue&type=script&lang=js&"
import style0 from "./JointEventContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports